import React from "react";
import { Link } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import Seo from "@/components/site/Seo";

export default function Result({ ok = true }) {
  return (
    <SiteLayout>
      <Seo title={ok ? "Booking Confirmed | The Sourcing Atlas" : "Payment Failed | The Sourcing Atlas"} description="Booking status." path={ok ? "/booking-confirmed" : "/payment-failed"} noindex />
      <div className="simplepage" style={{ textAlign: "center", paddingTop: 80, paddingBottom: 80 }} data-testid={ok ? "booking-confirmed" : "payment-failed"}>
        <div style={{ fontSize: 52 }}>{ok ? "✓" : "⚠️"}</div>
        <h1>{ok ? "Request received" : "Payment could not complete"}</h1>
        <p style={{ color: "var(--grey)", maxWidth: 520, margin: "10px auto 20px" }}>
          {ok
            ? "Thank you. Our team will send you a secure payment link and a booking reference within one business day."
            : "Your payment did not go through. No amount was captured. You can try again or contact our team for help."}
        </p>
        <Link className="btn btn-red" to={ok ? "/tours" : "/contact"}>{ok ? "Back to tours" : "Contact the team"}</Link>
      </div>
    </SiteLayout>
  );
}
